import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BreadcrumbsInterface } from 'common/types/entities/BreadcrumbsInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createBreadcrumbs(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
) {
  return {
    ...generateBaseEntity(EntityTypeEnum.Breadcrumbs, parentId, masterBlockId),
    fontSize: 20,
    itemColor: 'rgba(124, 124, 124, 1)',
    lastItemColor: 'rgba(20, 45, 99, 1)',
    margin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 10,
      marginLeft: 0,
    },
  }
}
